// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3yR6c){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_1bmRy .dualColumn_1Kj7Z{display:flex;align-content:space-between}.nsAddressForm_1bmRy .dualColumn_1Kj7Z .firstCol_2PiqW{margin-right:20px}.optional_2beH_{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3yR6c",
	"nsAddressForm": "nsAddressForm_1bmRy",
	"dualColumn": "dualColumn_1Kj7Z",
	"firstCol": "firstCol_2PiqW",
	"optional": "optional_2beH_"
};
module.exports = exports;
